export enum NameFormat {
  FirstLast = 'first_last',
  LastFirst = 'last_first'
}

export function getFullName(
  {
    first_name,
    last_name
  }: {
    first_name?: string | null;
    last_name?: string | null;
  },
  format: NameFormat = NameFormat.FirstLast
): string {
  const first = typeof first_name === 'string' ? first_name.trim() : '';
  const last = typeof last_name === 'string' ? last_name.trim() : '';

  if (format === NameFormat.LastFirst) {
    if (last && first) {
      return `${last}, ${first}`;
    }
    return [last, first].filter(Boolean).join(' ');
  }

  return [first, last].filter(Boolean).join(' ');
}
